import { render } from "./BasketView.vue?vue&type=template&id=34ba47be&scoped=true"
import script from "./BasketView.vue?vue&type=script&lang=js"
export * from "./BasketView.vue?vue&type=script&lang=js"

import "./BasketView.vue?vue&type=style&index=0&id=34ba47be&scoped=true&lang=css"
import "./BasketView.vue?vue&type=style&index=1&id=34ba47be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ba47be"]])

export default __exports__